var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"alert-heading"},[_vm._v("Page Not Found (404)")]),_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" The requested page could not be found. ")]),_c('b-link',{attrs:{"to":"/","variant":"primary"}},[_vm._v(" Go to Homepage ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }